export function fullName(somebody?: {
  firstName?: string;
  lastName?: string;
  middleName?: string;
}) {
  return `${somebody?.lastName || ''} ${somebody?.firstName || ''} ${somebody?.middleName || ''}`;
}
